import { Component, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { Log } from 'ng2-logger';
import { AdminService } from '../_services/admin.service';
import { AppService } from '../app.service';
import {ActivatedRoute, Router} from '@angular/router';
import {Tag} from '../_models/tag';
import {ToastsManager} from 'ng2-toastr';
import {ACLFeature} from '../_models/acl-feature';
import {Permissions} from '../_services/permissions';

const log = Log.create('CCC');

@Component({
    selector: 'edit-ccc',
    styleUrls: ['ccc.less'],
    templateUrl: 'ccc.component.html'
})

export class CccComponent implements OnInit, OnDestroy {
    canReadBridges = false;
    canReadSensors = false;
    canReadSensorAccessories = false;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private admin: AdminService,
        private appService: AppService,
        private renderer: Renderer2,
        private permissions: Permissions,
    ) {}

    ngOnInit() {
        this.appService.headerData.title = 'Compose and Connect Configurator';
        this.appService.headerData.path = [];

        this.permissions.hasFeature(ACLFeature.READ_BRIDGES)
            .subscribe((success) => {
                this.canReadBridges = success;
            });

        this.permissions.hasFeature(ACLFeature.READ_SENSORS)
            .subscribe((success) => {
                this.canReadSensors = success;
            });

        this.permissions.hasFeature(ACLFeature.READ_SENSOR_ACCESSORIES)
            .subscribe((success) => {
                this.canReadSensorAccessories = success;
            });

        this.renderer.addClass(document.body, 'edit-section-tags');
    }

    goTo(product) {
        switch (product) {
            case 'sensors':
                this.router.navigate(['/drilldown/sensors'], {relativeTo: this.route} );
                break;
            case 'sensor-accessories':
                this.router.navigate(['/drilldown/sensor-accessories'], {relativeTo: this.route} );
                break;
            case 'bridges':
                this.router.navigate(['/drilldown/bridges'], {relativeTo: this.route} );
                break;
        }
    }

    ngOnDestroy() {
        this.renderer.removeClass(document.body, 'edit-section-tags');
    }
}



// WEBPACK FOOTER //
// ./src/app/ccc/ccc.component.ts